<template>
  <div class="sponsors">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h5 class="sponsors__title">{{$store.getters.t('sponsors_title')}}</h5>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <template v-if="loading">
            <div class="d-flex common-block">
              <div class="LoaderBalls">
                <div class="LoaderBalls__item"></div>
                <div class="LoaderBalls__item"></div>
                <div class="LoaderBalls__item"></div>
              </div>
            </div>
          </template>
          <template v-else>
            <swiper ref="swiper" class="swiper" :options="swiperOptions">
              <swiper-slide v-for="slide in sponsors" :key="slide.id">
                <div class="sponsors__item">
                  <div class="sponsors__item-inner d-flex">
                    <div class="sponsors__logo">
                      <img :src="slide.main_image.path" alt="" />
                    </div>

                    <div class="sponsors__donation">
                      {{ slide.title }}
                    </div>

                    <div class="sponsors__description">
                      {{ slide.data }}
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>

            <div class="d-flex mt-5 sponsors__nav" v-if="sponsors.length">
              <div class="slider-navigations d-flex">
                <div
                  id="sponsors-prev"
                  class="swiper-button-prev"
                  slot="button-prev"
                ></div>
                <div
                  id="sponsors-next"
                  class="swiper-button-next"
                  slot="button-next"
                ></div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { getContentBlock } from "./api/get-content-block"

const defaultSponsors = [
  {
    id: 1,
    main_image: { path: "/assets/images/icons/saygames.png" },
    title: "25 635,00 EUR",
    data:
      "We are a mobile game publisher. We help developers of all sizes release great games that will be played by millions of players around the world. Join us and let’s work together!",
  },
  {
    id: 2,
    main_image: { path: "/assets/images/icons/vizor.svg" },
    title: "12 681,00 EUR",
    data:
      "В Vizor Games знают все о фермах и экспедициях и искусно совмещаем эти механики в мобильных и социальных играх. Компания также занимается разработкой крупных проектов для ПК и консолей.",
  },
  {
    id: 3,
    main_image: { path: "/assets/images/icons/playrix.svg" },
    title: "12 084,00 EUR",
    data:
      "Playrix - крупнейшая игровая компания и входит в Топ-3 самых успешных мобильных разработчиков в мире. В наши хиты Manor Matters, Wildscapes, Homescapes, Gardenscapes, Fishdom и Township каждый месяц играют более 130 миллионов человек. Мы верим, что наш  прорывной опыт и знания в игровой индустрии, можно спроецировать на любую другую сферу, в том числе и на помощь животным!",
  },
  {
    id: 4,
    main_image: { path: "/assets/images/icons/RTL_logo.png" },
    title: "2000,00 EUR",
    data:
      "Команда RTL Alliance предоставляет логистические услуги с 2012 года. Благодаря нам грузы любого назначения и объема доставляются из пункта А в пункт Б своевременно и безопасно. Может, именно вашу стиральную машину или холодильник привезли мы? 😉 RTL не устает раздвигать границы логистической отрасли и прокладывать новые маршруты. Но это не единственное, что нас сплачивает. Мы любим любить и быть полезными и доставляем не только грузы, но и радость. В том числе и маленьким хвостатым пушистикам. Ребята из RTL постоянно участвуют в благотворительных акциях, волонтерских движениях. Мысль, что наши действия спасают кому-то жизнь или избавляют от голода, побуждает нас не останавливаться, а двигаться только вперед.",
  },
];

export default {
  name: "Sponsors",
  components: { Swiper, SwiperSlide },
  data() {
    return {
      sponsors: [],
      loading: false,
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 32,
        loop: true,
        navigation: {
          nextEl: "#sponsors-next",
          prevEl: "#sponsors-prev",
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 2,
            spaceBetween: 32,
          },
        },
      },
    };
  },
  CONTEN_BLOCK_NAME: "main_sponsors",
  mounted() {
    this.getSponsors();
  },

  methods: {
    getSponsors() {
      this.loading = true;
      let { CONTEN_BLOCK_NAME } = this.$options;

      getContentBlock(CONTEN_BLOCK_NAME)
        .then(({ items = [] }) => {
          if ( items.length ) {
            this.sponsors = items.map((it) => {
              if( it.main_image ) it.main_image.path = `/storage/${it.main_image.path}`;

              return it;
            });
          }
          if ( ! items.length ) this.sponsors = defaultSponsors;
          this.loading = false;
        })
        .catch((e) => {
          this.sponsors = defaultSponsors;
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.sponsors {
  background-image: url("/assets/images/sponsors.svg");
  background-color: #eff1f3;
  background-size: 91%;
  background-repeat: no-repeat;
  padding-top: 95px;
  padding-bottom: 55px;
  background-position-y: 30px;
  background-position-x: 0;

  position: relative;

  &__title {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 45px;
    color: #333333;
  }

  &__item {
    position: relative;
    padding: 35px 24px 16px;
    border-radius: 5px;
    overflow: hidden;
    background: #fff;
    height: 100%;
    border-top: 6px solid #2e76e4;
    box-shadow: 0px 0px 2px 0px #0000001a;

    &::after {
      position: absolute;
      display: block;
      content: "";

      border-radius: 50%;
      width: 175px;
      height: 175px;
      overflow: hidden;
      background: #eaf1fc url("/assets/images/icons/sponsors-money.svg")
        no-repeat center/55px 100px;
      bottom: -35px;
      right: -50px;
      opacity: 0.3;
    }

    &-inner {
      position: relative;
      z-index: 1;
      flex-direction: column;
    }
  }

  &__logo {
    flex-grow: 1;
    margin-bottom: 20px;
    width: 100%;
    height: 37px;
    max-width: 140px;
  }

  &__donation {
    position: relative;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 12px;
    width: intrinsic; /* Safari/WebKit используют нестандартное имя */
    width: -moz-max-content; /* Firefox/Gecko */
    width: -webkit-max-content; /* Chrome */
    padding-bottom: 12px;

    &::after {
      position: absolute;
      display: block;
      content: "";
      right: 0;
      left: 0;
      bottom: 0;
      height: 2px;
      background: #2e76e4;
      border-radius: 5px;
    }
  }

  &__description {
    font-size: 12px;
    line-height: 18px;
    color: #555;
    padding-right: 110px;
  }

  .swiper-slide {
    height: auto;
    &:nth-child(even) {
      .sponsors__item {
        border-color: #6c4dbb;
      }
    }
  }

  .slider-navigations {
    margin: 0 auto;
  }

  .swiper-button-next,
  .swiper-button-prev {
    position: static;
    background: #fff;
    border-radius: 20px;
    width: 56px;
    height: 40px;
    outline: none;
    margin: 0 10px;

    &::after {
      color: transparent;
      background: transparent url(/assets/images/slide-arw-right.svg) no-repeat;
      background-size: contain;
      background-position: 50% 50%;
    }
  }
  .swiper-button-prev {
    &::after {
      transform: rotate(180deg);
    }
  }
}
@media screen and(max-width: 768px) {
  .sponsors__title {
    font-size: 26px;
    line-height: 30px;
    text-align: center;
  }
}

@media screen and(max-width: 480px) {
  .sponsors__description {
    padding-right: 30px;
  }
}
</style>
